import React, { createContext, useContext, useState } from 'react';

const MobileHeaderContext = createContext({
  headerLeftAction: null,
  setHeaderLeftAction: () => {},
});

export const useMobileHeader = () => useContext(MobileHeaderContext);

export const MobileHeaderProvider = ({ children }) => {
  const [headerLeftAction, setHeaderLeftAction] = useState(null);

  const contextValue = {
    headerLeftAction,
    setHeaderLeftAction,
  };

  return (
    <MobileHeaderContext.Provider value={contextValue}>
      {children}
    </MobileHeaderContext.Provider>
  );
};
